export default __webpack_public_path__ + "static/media/per.f45a618e.png";